import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import Skeleton from '@ynap/skeleton';

const bem = new BEMHelper('ProductDetailsSkeleton');

const propTypes = {
    className: PropTypes.string,
};

export function ProductDetailsSkeletonBasicInfo({ className }) {
    return (
        <div className={bem('productDetailsSkeletonWrapper', 'basicInfo', className)}>
            <Skeleton containerClassName={bem('skeletonComponent', null, className)} className={bem('designerName')} count={1} />
            <Skeleton containerClassName={bem('skeletonComponent', null, className)} className={bem('productName')} count={1} />
            <Skeleton containerClassName={bem('skeletonComponent', null, className)} className={bem('badge')} count={1} />
            <Skeleton containerClassName={bem('skeletonComponent', null, className)} className={bem('price')} count={1} />
        </div>
    );
}

export function ProductDetailsSkeletonDetails({ className }) {
    return (
        <div className={bem('productDetailsSkeletonWrapper', 'productDetails', className)}>
            <Skeleton containerClassName={bem('skeletonComponent', null, className)} className={bem('editorialNotes')} count={4} />
            <Skeleton containerClassName={bem('skeletonComponent', null, className)} className={bem('partNumber')} count={1} />
        </div>
    );
}

export function ProductDetailsControls({ className, withQuickAdd = false }) {
    return (
        <div className={bem('productDetailsSkeletonWrapper', 'controls', className)}>
            {!withQuickAdd && <Skeleton containerClassName={bem('skeletonComponent', 'color', className)} className={bem('color')} count={1} />}
            <Skeleton containerClassName={bem('skeletonComponent', null, className)} className={bem('sizeSelect')} count={1} />
            <Skeleton containerClassName={bem('skeletonComponent', null, className)} className={bem('cta')} count={1} />
        </div>
    );
}

ProductDetailsSkeletonBasicInfo.propTypes = propTypes;
ProductDetailsSkeletonDetails.propTypes = propTypes;
ProductDetailsControls.propTypes = {
    ...propTypes,
    withQuickAdd: PropTypes.boolean,
};
